<template>
	<div>
		<button 
			class="btn mt-4 dm-btn-padding dm-view-as-pdf"
			@click="openSignInModal()">Download Material</button>

		<modal size="lg" id="dm-signup-modal" title="Create an Account">
			<div class="card-body pt-3 pb-3">
				<SignUpForm 
					@showSignInModal="openSignInModal()"
					@showSignUpModal="openSignUpModal()"
					@closeAllModals="closeAllModals()" />
			</div>
		</modal>

		<modal size="lg" id="dm-signin-modal" title="Log in">
			<div class="card-body pt-3 pb-3">
				<SignInForm
					@showSignUpModal="openSignUpModal()"
					@closeAllModals="closeAllModals()" />
			</div>
		</modal>
	</div>
</template>

<script>
import SignUpForm from "./forms/SignUpForm.vue";
import SignInForm from "./forms/SignInForm.vue";
export default {
	components: { SignUpForm, SignInForm },
    data() {
        return {
            signUpModal: null,
            signInModal: null,
        };
    },
    methods: {
        openSignUpModal() {
            this.closeAllModals();
            this.signUpModal.show();
        },
        openSignInModal() {
            this.closeAllModals();
            this.signInModal.show();
        },
        closeAllModals() {
            this.signUpModal.hide();
            this.signInModal.hide();
        }
    },
    mounted() {
        var self = this;
        setTimeout(function () {
            self.signUpModal = new bootstrap.Modal("#dm-signup-modal");
            self.signInModal = new bootstrap.Modal("#dm-signin-modal");
        }, 500);
    }
}
</script>
